// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__8KPJa","headerTitleCont":"Modal_headerTitleCont__AVkfg","title":"Modal_title__JWNyA"};